import config from '../../config';
class NpsScoreController {
  constructor(Authentication, PersonaCollection, SubscriptionUtils, $rootScope, $timeout) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      SubscriptionUtils,
      $rootScope,
      $timeout,
    });
  }

  $onInit() {
    this.user = null;
    this.initNps();
  }

  async initNps() {
    if (!config.NPS_SURVEY_ENABLED) {
      return;
    }

    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;
    await this.$timeout(1000);

    this.user = this.Authentication.user;
    this.saveClientFlags = this.Authentication.saveClientFlags;
    const { isPremium, premiumTrialStartDate, subscriptionStartDate } = this.user.org;
    const isOnTrial = isPremium && premiumTrialStartDate && !subscriptionStartDate;
    this.subscriptionName = this.SubscriptionUtils.getSubscriptionNameDetailed(
      this.user.org.subscriptionLevel,
      isOnTrial
    );
  }

  onClose() {
    this.$rootScope.forceNpsDisplay = false;
  }

  get usersCount() {
    return this.PersonaCollection.users.length;
  }

  get locationsCount() {
    return this.PersonaCollection.locations.length;
  }

  get forceDisplay() {
    return this.$rootScope.forceNpsDisplay || false;
  }
}

export default {
  template: `
    <r-nps-score ng-if="!!ctrl.user && ctrl.usersCount"
      user="ctrl.user"
      users-count="ctrl.usersCount"
      locations-count="ctrl.locationsCount"
      subscription-name="{{ctrl.subscriptionName}}"
      save-client-flags="ctrl.saveClientFlags(flags)"
      on-close="ctrl.onClose()"
      force-display="ctrl.forceDisplay">
    </r-nps-score>
    `,
  controller: NpsScoreController,
  controllerAs: 'ctrl',
};
